import React, { useState, useEffect, useContext, useRef } from 'react';
import axios from 'axios';
import {
  Box,
  Chip,
  Typography,
  Paper,
  Button // Add this import
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from './../../AuthContext/AuthContext';
import buildingImage from './../../../Images/house.jpeg';
import CustomSearchBar from './../Lease Module/CustomSearchBar';
import ReUsableCard from './ReUsableCard';
import CustomBottomNav from './CustomNavbarHotProperties';
import { BASE_URL } from './../../Api/ApiUrls';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';


// Fix for default marker icons in Leaflet
import markerIcon2x from 'leaflet/dist/images/marker-icon-2x.png';
import markerIcon from 'leaflet/dist/images/marker-icon.png';
import markerShadow from 'leaflet/dist/images/marker-shadow.png';

delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: markerIcon2x,
  iconUrl: markerIcon,
  shadowUrl: markerShadow
});

// const rentalTypes = [
//   "PLOT/LAND", "VILLA", "APARTMENT"
// ];

const rentalTypes = [
    "PLOT/LAND", "VILLA", "APARTMENT"
  ];

  const rentalTypeDisplayMap = {
    "PLOT/LAND": "PLOTS",
    "VILLA": "VILLAS",
    "APARTMENT": "APARTMENTS"
  };

const Hot_Property_Map = () => {
  // State declarations
  const [selectedProperty, setSelectedProperty] = useState(null);
  const [properties, setProperties] = useState([]);
  const [filteredProperties, setFilteredProperties] = useState([]);
  const [selectedType, setSelectedType] = useState(null);
  const [searchLocation, setSearchLocation] = useState(null);
  const [searchRadius] = useState(10000);
  const [saved, setSaved] = useState(() => {
    const stored = localStorage.getItem('savedHot');
    return stored ? JSON.parse(stored) : [];
  });
  const [categories, setCategories] = useState([]);
  const [likedCards, setLikedCards] = useState({});
  const { userId, logout } = useContext(AuthContext);
  const [savedProperties, setSavedProperties] = useState([]);
  const [saving, setSaving] = useState({});
  const navigate = useNavigate();
  const [priceFilter, setPriceFilter] = useState(null);
  const mapContainerRef = useRef(null);
  const [map, setMap] = useState(null);
  const [markers, setMarkers] = useState([]);
  const [mapLoaded, setMapLoaded] = useState(false);

         const [isSubscribed, setIsSubscribed] = useState(false);
  const [maxZoom, setMaxZoom] = useState(11); // Default max zoom for non-subscribed users
  
  
 const [mapKey, setMapKey] = useState(0);
useEffect(() => {
 
 const checkSubscription = async () => {
    try {
      console.log('Checking subscription for user:', userId);
      const response = await axios.get(`${BASE_URL}/Get-user-plan/${userId}/`);
      const userSubscriptions = response.data;

      console.log('Found subscriptions:', userSubscriptions);
      
      // Check if any subscription matches the Buyer type
      const hasBuyerSubscription = Array.isArray(userSubscriptions) && 
        userSubscriptions.some(sub => sub.user_type === "Buyer");

      if (hasBuyerSubscription) {
        console.log('User is subscribed and is a Buyer, setting max zoom to 20');
        setIsSubscribed(true);
        setMaxZoom(20);
      } else {
        console.log('User is NOT subscribed or not a Buyer, keeping max zoom at 11');
        setIsSubscribed(false);
        setMaxZoom(11);
      }
    } catch (error) {
      console.error('Error checking subscription:', error);
      setIsSubscribed(false);
      setMaxZoom(11);
    }
  };

  if (userId) {
    checkSubscription();
  } else {
    console.log('No user ID, defaulting to non-subscribed zoom limits');
    setIsSubscribed(false);
    setMaxZoom(11);
  }
}, [userId]);


  // Function to determine marker color based on property age
  const getMarkerColor = (createdAt) => {
    if (!createdAt) return '#808080'; // Default gray if no date
    const createdDate = new Date(createdAt);
    const now = new Date();
    const diffTime = Math.abs(now.getTime() - createdDate.getTime());
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    const diffMonths = diffDays / 30.44;

    if (diffMonths <= 3) return '#008000'; // Green - <3 months
    if (diffMonths <= 6) return '#FFFF00'; // Yellow - 3-6 months
    if (diffMonths <= 12) return '#FFA500'; // Orange - 6-12 months
    return '#FF0000'; // Red - >1 year
  };

  // Function to format price for marker display
  const getPriceLabel = (price) => {
    if (price >= 10000000) return `${Math.round(price / 10000000)} Cr`;
    if (price >= 100000) return `${Math.round(price / 100000)} L`;
    if (price >= 1000) return `${Math.round(price / 1000)} K`;
    return `${price}`;
  };

// Initialize Leaflet Map with proper cleanup
useEffect(() => {
  if (!mapContainerRef.current) return;

  console.log('Initializing Leaflet map...');
  
  const hyderabadCoords = [17.3850, 78.4867];
  const initialZoom = searchLocation ? 12 : 7;
  
  const leafletMap = L.map(mapContainerRef.current, {
    center: searchLocation ? [searchLocation.lat, searchLocation.lng] : hyderabadCoords,
    zoom: initialZoom,
    zoomControl: false,
    maxZoom: maxZoom
  });

  // Add tile layer
  const tileLayer = L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
    attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
    maxNativeZoom: maxZoom
  }).addTo(leafletMap);

  // Add zoom control
  const zoomControl = L.control.zoom({ position: 'topright' }).addTo(leafletMap);

  // Zoom restriction handler
  const handleZoomEnd = () => {
    try {
      const currentZoom = leafletMap.getZoom();
      if (!isSubscribed && currentZoom > 11) {
        leafletMap.setZoom(11);
      }
    } catch (error) {
      console.error('Error handling zoom:', error);
    }
  };

  leafletMap.on('zoomend', handleZoomEnd);

  setMap(leafletMap);
  setMapLoaded(true);

  return () => {
    try {
      if (leafletMap) {
        leafletMap.off('zoomend', handleZoomEnd);
        leafletMap.remove();
      }
    } catch (error) {
      console.error('Error cleaning up map:', error);
    }
  };
}, [isSubscribed, maxZoom, searchLocation]);
useEffect(() => {
  if (!mapLoaded || !map || !filteredProperties.length) return;

  // Create a marker cache to prevent flickering
  const markerCache = new Map();

  const renderMarkers = () => {
    const currentZoom = map.getZoom();
    const showPriceLabels = currentZoom >= 13;

    // First pass: remove markers that shouldn't be visible
    markers.forEach(marker => {
      const shouldBeVisible = filteredProperties.some(
        p => p.id === marker.options.propertyId
      );
      
      if (!shouldBeVisible && map.hasLayer(marker)) {
        map.removeLayer(marker);
      }
    });

    // Second pass: update or create markers
    const newMarkers = filteredProperties
      .filter(property => property.lat && property.lng)
      .map(property => {
        try {
          // Check if marker already exists
          const existingMarker = markers.find(m => m.options.propertyId === property.id);
          
          if (existingMarker && map.hasLayer(existingMarker)) {
            // Update existing marker
            const markerColor = getMarkerColor(property.createdAt);
            const price = parseInt(property.price.replace(/[^\d]/g, '')) || 0;
            const priceLabel = showPriceLabels ? getPriceLabel(price) : null;
            
            existingMarker.setIcon(createMarkerIcon(markerColor, priceLabel));
            return existingMarker;
          }

          // Create new marker
          const markerColor = getMarkerColor(property.createdAt);
          const price = parseInt(property.price.replace(/[^\d]/g, '')) || 0;
          const priceLabel = showPriceLabels ? getPriceLabel(price) : null;

          const marker = L.marker([property.lat, property.lng], {
            icon: createMarkerIcon(markerColor, priceLabel),
            propertyId: property.id
          }).addTo(map);

          marker.on('click', () => {
            setSelectedProperty(property);
          });

          return marker;
        } catch (error) {
          console.error('Error creating marker:', error);
          return null;
        }
      })
      .filter(Boolean);

    setMarkers(newMarkers);
  };

  const createMarkerIcon = (color, priceLabel) => {
    const size = priceLabel ? 28 : 12;
    const translate = priceLabel ? -14 : -6;
    
    return L.divIcon({
      className: 'custom-marker',
      html: `
        <div style="
          background-color: ${color};
          width: ${size}px;
          height: ${size}px;
          border-radius: 50%;
          border: 2px solid white;
          display: flex;
          justify-content: center;
          align-items: center;
          color: white;
          font-weight: bold;
          font-size: ${priceLabel ? '10px' : '0'};
          transform: translate(${translate}px, ${translate}px);
          transition: all 0.2s ease;
        ">
          ${priceLabel || ''}
        </div>
      `,
      iconSize: [size, size],
      iconAnchor: [size / 2, size / 2],
    });
  };

  // Initial render
  renderMarkers();

  // Fit bounds
  if (!searchLocation && filteredProperties.length > 0) {
    try {
      const coords = filteredProperties
        .filter(p => p.lat && p.lng)
        .map(p => [p.lat, p.lng]);

      if (coords.length > 0) {
        const bounds = L.latLngBounds(coords);
        map.fitBounds(bounds, { 
          padding: [50, 50],
          maxZoom: 12
        });
      }
    } catch (error) {
      console.error('Error fitting bounds:', error);
      map.setView([17.3850, 78.4867], 11);
    }
  }

  // Zoom handler with debounce
  let zoomEndTimeout;
  const handleZoomEnd = () => {
    clearTimeout(zoomEndTimeout);
    zoomEndTimeout = setTimeout(renderMarkers, 100);
  };

  map.on('zoomend', handleZoomEnd);

  return () => {
    clearTimeout(zoomEndTimeout);
    map.off('zoomend', handleZoomEnd);
    markers.forEach(marker => {
      if (map.hasLayer(marker)) {
        map.removeLayer(marker);
      }
    });
  };
}, [map, mapLoaded, filteredProperties, searchLocation]);


useEffect(() => {
  if (!mapLoaded || !map || !searchLocation?.lat || !searchLocation?.lng) return;

  // Debug check
  console.log("Setting map view from searchLocation:", searchLocation);

  try {
    map.setView([searchLocation.lat, searchLocation.lng], 12);
  } catch (error) {
    console.error('Error setting map view:', error);
  }
}, [map, mapLoaded, searchLocation]);

  // Fetch saved properties from API
  useEffect(() => {
    const fetchSavedProperties = async () => {
      try {
        const response = await axios.get(`${BASE_URL}/get-user-cart/${userId}/`);
        const savedItems = Array.isArray(response.data) ? response.data : [];
        setSavedProperties(savedItems.map(item => item.property_id));
      } catch (error) {
        console.error('Error fetching saved properties:', error);
        setSavedProperties([]);
      }
    };

    if (userId) {
      fetchSavedProperties();
    }
  }, [userId]);

  // Fetch properties data
  useEffect(() => {
    const fetchProperties = async () => {
      try {
        const categoriesResponse = await axios.get(`${BASE_URL}/property-category/`);
        setCategories(categoriesResponse.data);

        const propertiesResponse = await axios.get(`${BASE_URL}/property/`);
        const filtered = propertiesResponse.data.filter(item =>
          item.type == "best-deal" && item.Admin_status == "Approved"
        );

        const parsed = filtered.map(item => {
          const parseCoord = (coord) => {
            if (!coord) return null;
            const cleaned = coord.replace(/"/g, '').replace(':', '.');
            return parseFloat(cleaned);
          };

          const matchedCategory = categoriesResponse.data.find(
            cat => cat.category_id == item.category_id
          );

          const categoryName = matchedCategory ? matchedCategory.category : 'Property';

          const images = item.property_images?.length > 0
            ? item.property_images.map(img => `${BASE_URL}${img.image}`)
            : [buildingImage];

          return {
            id: item.property_id,
            title: categoryName,
            location: item.location || 'Not specified',
            price: `₹${item.price}`,
            date: item.created_at?.split('T')[0],
            facing: item.facing?.replace(/"/g, '') || 'N/A',
            area: item.site_area ? `${item.site_area} sq ft` : 'N/A',
            dimensions: item.roadwidth ? `${item.roadwidth} ft road` : 'N/A',
            listedBy: item.posted_by?.replace(/"/g, '') || 'Agent',
            lat: parseCoord(item.lat),
            lng: parseCoord(item.long),
            length: item.length,
            width: item.width,
            property_name: item.property_name,
            mobile_no: item.mobile_no,
admin_mobile: item.admin_mobile,         
   images: images,
            propertyData: item,
            owner:item.user_id,
            createdAt: item.created_at // Added for marker coloring
          };
        });

        setProperties(parsed);
      } catch (error) {
        console.error('Error fetching properties:', error);
      }
    };

    fetchProperties();
  }, []);

  // Filter properties based on selected type and price
  useEffect(() => {
    if (properties.length === 0) return;

    const filtered = (selectedType || priceFilter)
      ? properties.filter(p => {
          const typeMatch = !selectedType || 
            p.title.toLowerCase().includes(selectedType.toLowerCase());
          
          const priceMatch = !priceFilter || 
            (p.propertyData.price >= priceFilter.min && 
             p.propertyData.price <= priceFilter.max);
          
          return typeMatch && priceMatch;
        })
      : properties;

    setFilteredProperties(filtered);
  }, [properties, selectedType, priceFilter]);

  // API functions for cart operations
  const addToCart = async (propertyId) => {
    try {
      const response = await axios.post(`${BASE_URL}/user-cart/`, {
        user_id: userId,
        property_id: propertyId
      });
      return response.data;
    } catch (error) {
      console.error('Error adding to cart:', error);
      throw error;
    }
  };

 const removeFromCart = async (propertyId) => {
     try {
       const cartResponse = await axios.get(`${BASE_URL}/user-cart/?user_id=${userId}&property_id=${propertyId}`);
       if (cartResponse.data && cartResponse.data.length > 0) {
         await axios.delete(`${BASE_URL}/user-cart/${cartResponse.data[0].cart_id}/`);
       }
     } catch (error) {
       console.error('Error removing from cart:', error);
       throw error;
     }
   };
  const toggleSave = async (property) => {
    const propertyId = property.id;
    setSaving(prev => ({ ...prev, [propertyId]: true }));
    
    try {
      const isSaved = savedProperties.includes(propertyId);
      
      if (isSaved) {
        await removeFromCart(propertyId);
        setSavedProperties(prev => prev.filter(id => id !== propertyId));
      } else {
        await addToCart(propertyId);
        setSavedProperties(prev => [...prev, propertyId]);
      }
    } catch (error) {
      console.error('Error updating saved properties:', error);
    } finally {
      setSaving(prev => ({ ...prev, [propertyId]: false }));
    }
  };
    
  const isSaved = (property) => savedProperties.includes(property.id);

  const toggleLike = (id) => {
    setLikedCards((prev) => ({
      ...prev,
      [id]: !prev[id]
    }));
  };

  // Load from localStorage on mount
  useEffect(() => {
    const stored = localStorage.getItem('selectedLocation');
    if (stored) {
      setSearchLocation(JSON.parse(stored));
    }
  }, []);

  const handleSelectedLocation = (locationData) => {
   // localStorage.setItem('selectedLocation', JSON.stringify(locationData));
    setSearchLocation(locationData);
  };
  
  const handlePriceFilterChange = (range) => {
    setPriceFilter(range);
  };

  // const clearSearch = () => {
  //   localStorage.removeItem('selectedLocation');
  //   setSearchLocation(null);
  // };
   const clearSearch = () => {
  // Clear all relevant data
  localStorage.removeItem('savedSearchValue');
  localStorage.removeItem('selectedLocation');
  localStorage.removeItem('recentLocationSearches');
  
  // Reset states
  setSearchLocation(null);
  setSelectedProperty(null);
  
  // Force map remount by changing the key
  setMapKey(prev => prev + 1);
  
  // Clean up existing map if it exists
  if (map) {
    try {
      // Remove all layers first
      map.eachLayer(layer => {
        map.removeLayer(layer);
      });
      
      // Then remove the map
      map.remove();
      setMap(null);
    } catch (error) {
      console.error('Error cleaning up map:', error);
    }
  }
  
  // Reset map loaded state
  setMapLoaded(false);
};


  return (
    <Box
      sx={{
        pb: 7,
        maxWidth: 480,
        mx: "auto",
        position: 'relative',
        backgroundColor: 'rgb(239, 231, 221)',
        minHeight: '100vh'
      }}
    >
     
      {/* Search Bar */}
      <Box
        sx={{
          position: 'sticky',
          top: 0,
          zIndex: 1000,
          bgcolor: 'rgb(239, 231, 221)',
          px: 1,
          py: 1,
        }}
      >
        <CustomSearchBar 
          onPlaceSelected={handleSelectedLocation} 
          onClear={clearSearch}
          onPriceFilterChange={handlePriceFilterChange}
        />
      </Box>

      {/* Property Types */}
      <Box sx={{ px: 2 }}>
        <Typography variant="subtitle1" sx={{ mb: 1 }}>Hot Properties </Typography>
        <Box
          sx={{
            display: 'flex',
            gap: 1,
            overflowX: 'auto',
            whiteSpace: 'nowrap',
            pb: 1,
          }}
        >
          {rentalTypes.map((type, index) => (
            <Chip
              key={index}
             label={rentalTypeDisplayMap[type] || type}
              variant="filled"
              onClick={() => {
                setSelectedProperty(null);
                setSelectedType(prev => (prev === type ? null : type));
              }}
              sx={{
                flexShrink: 0,
                bgcolor: selectedType === type ? '#000000' : 'transparent',
                color: selectedType === type ? '#ffffff' : '#000000',
                border: '1px solid black',
                fontWeight: 'bold',
                '&:hover': {
                  bgcolor: selectedType === type ? '#000000' : 'rgba(0, 0, 0, 0.1)',
                },
              }}
            />
          ))}
        </Box>
      </Box>

      {/* No properties message */}
      {(selectedType || priceFilter) && filteredProperties.length === 0 && (
        <Box sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '200px',
          px: 2,
          textAlign: 'center'
        }}>
          <Box sx={{
            backgroundColor: 'rgba(255, 255, 255, 0.9)',
            padding: '16px',
            borderRadius: '8px',
            textAlign: 'center'
          }}>
            <Typography variant="h6">
              No properties found
            </Typography>
            <Typography variant="body2" sx={{ mt: 1 }}>
              {selectedType && `Category: "${selectedType}"`}
              {selectedType && priceFilter && ' • '}
              {priceFilter && `Price: ${priceFilter.label}`}
            </Typography>
          </Box>
        </Box>
      )}

      {/* Leaflet Map Container */}
{(!selectedType || filteredProperties.length > 0) && (
  <Box sx={{ px: 2, pb: 10, position: 'relative' }}>
    {!isSubscribed && (
      <Box sx={{
        position: 'absolute',
        top: 10,
        right: 10,
        zIndex: 1000,
        backgroundColor: 'rgba(255,255,255,0.9)',
        padding: '8px 12px',
        borderRadius: '4px',
        boxShadow: '0 2px 4px rgba(0,0,0,0.2)',
        display: 'flex',
        alignItems: 'center'
      }}>
        <Typography variant="body2" sx={{ mr: 1 }}>
          Zoom in restricted for free users
        </Typography>
        <Button 
          variant="contained" 
          size="small"
          onClick={() => navigate('/user-subscription')}
        >
          Upgrade
        </Button>
      </Box>
    )}
     <div 
    ref={mapContainerRef} 
    key={`map-${mapKey}`}  // This will force remount when key changes
    style={{ 
      width: '100%', 
      height: 'calc(100vh - 240px)',
      borderRadius: '8px',
      overflow: 'hidden',
      backgroundColor: '#f0f0f0'
    }} 
  >
    {!mapLoaded && (
      <Box sx={{ display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100%' }}>
        <Typography>Loading map...</Typography>
      </Box>
    )}
  </div>

          {/* Property Card Popup */}
          {selectedProperty && (
            <Box sx={{
              position: 'absolute',
              bottom: 67,
              left: 0,
              right: 0,
              margin: '0 auto',
              width: '100%',
              maxWidth: 480,
              zIndex: 999
            }}>
              <ReUsableCard
                property={selectedProperty}
                onCardClick={() => {
                  if (selectedProperty && selectedProperty.id) {
                    navigate('/hot-property-description', {
                      state: { propertyId: selectedProperty.id }
                    });
                  }
                }}
                isSaved={isSaved}
                toggleSave={toggleSave}
                likedCards={likedCards}
                toggleLike={toggleLike}
                onClose={() => setSelectedProperty(null)}
                saving={saving[selectedProperty.id]}
                isSubscribed={isSubscribed}  // Add this line
              />
            </Box>
          )}
        </Box>
      )}

      {/* Bottom Navigation */}
      <Paper sx={{ position: 'fixed', bottom: 0, left: 0, right: 0 }} elevation={3}>
        <CustomBottomNav />
      </Paper>
     
    </Box>
    
  );
};

export default Hot_Property_Map;